// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-dot{width:43px;height:43px;border-radius:0;background-color:pink;-webkit-transition:all .3s;transition:all .3s;border-radius:50%;text-align:center;line-height:43px}.custom-dot,.custom-dot:hover{-webkit-transform:translateY(8px) translateY(-21.5px);transform:translateY(8px) translateY(-21.5px)}.custom-dot.focus{border-radius:50%}", ""]);
